import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { progressActions } from '../actions/progress.actions';
import {
    selectLoaded,
    selectLoading,
    selectLessonsCompleted,
    selectIsLessonCompleted,
    selectQuizzesCompleted,
    selectIsQuizCompleted,
    selectItemsCompleted,
    selectModulesCompleted,
    selectCoursesCompleted,
    selectIsCourseCompleted,
} from '../selectors/progress.selectors';

@Injectable({
    providedIn: 'root',
})
export class ProgressFacade {
    private readonly store = inject(Store);

    // rxjs
    readonly loaded$ = this.store.select(selectLoaded);
    readonly loading$ = this.store.select(selectLoading);
    readonly coursesCompleted$ = this.store.select(selectCoursesCompleted);
    readonly lessonsCompleted$ = (courseId: string) => this.store.select(selectLessonsCompleted(courseId));
    readonly quizzesCompleted$ = (courseId: string) => this.store.select(selectQuizzesCompleted(courseId));
    readonly itemsCompleted$ = (courseId: string) => this.store.select(selectItemsCompleted(courseId));
    readonly modulesCompleted$ = (courseId: string) => this.store.select(selectModulesCompleted(courseId));

    // signals
    readonly loaded = this.store.selectSignal(selectLoaded);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly coursesCompleted = this.store.selectSignal(selectCoursesCompleted);
    readonly lessonsCompleted = (courseId: string) => this.store.selectSignal(selectLessonsCompleted(courseId));
    readonly quizzesCompleted = (courseId: string) => this.store.selectSignal(selectQuizzesCompleted(courseId));
    readonly itemsCompleted = (courseId: string) => this.store.selectSignal(selectItemsCompleted(courseId));
    readonly isLessonCompleted = (id: string) => this.store.selectSignal(selectIsLessonCompleted(id));
    readonly isQuizCompleted = (quizId: string) => this.store.selectSignal(selectIsQuizCompleted(quizId));
    readonly modulesCompleted = (courseId: string) => this.store.selectSignal(selectModulesCompleted(courseId));
    readonly isCourseCompleted = (courseId: string) => this.store.selectSignal(selectIsCourseCompleted(courseId));

    markAsCompleted(lessonId: string) {
        const value = { lessonId };

        this.store.dispatch(progressActions.markAsCompleted({ value }));
    }

    markAsUncompleted(lessonId: string) {
        const value = { lessonId };

        this.store.dispatch(progressActions.markAsUncompleted({ value }));
    }

    clear() {
        this.store.dispatch(progressActions.clear());
    }
}
